export const login = (email, password) => {
  return (dispatch, getState) => {
    let headers = {"Content-Type": "application/json"};
    let body = JSON.stringify({email, password});

    return fetch("/token-auth/", {headers, body, method: "POST"})
      .then(res => {
        if (res.status < 500) {
          return res.json().then(data => {
            return {status: res.status, data};
          })
        } else {
          console.log("Server Error!");
          throw res;
        }
      })
      .then(res => {
        let user = {};
        if (res.status === 200) {
          user.email= res.data.user.email;
          
          if(res.data.user.is_superuser) {
            user.name= "Admin"
        
          } else if(res.data.user.is_verifier) {
            user.name= res.data.user.email_address
            
          } else {
            user.name = res.data.user.locations[0].name
            
          }
          user.digest = res.data.user.digest;
          window.MissiveChat.setUser(user);
          dispatch({type: 'LOGIN_SUCCESSFUL', data: res.data });
          return res.data;
        } else if (res.status === 403 || res.status === 401) {
          dispatch({type: "AUTHENTICATION_ERROR", data: res.data});
          throw res.data;
        } else {
          dispatch({type: "LOGIN_FAILED", data: res.data});
          throw res.data;
        }
      })
  }
}

export const logout = () => {
  return (dispatch, getState) => {
    dispatch({type: 'LOGOUT_SUCCESSFUL'});
  }
}

export const hideWalkthroughModal = () => {
  return (dispatch, getState) => {
    dispatch({type: 'HIDE_WALKTHROUGH_MODAL'});
  }

}



// WEBPACK FOOTER //
// ./src/redux/actions/auth.js